// React libs
import { useState, useEffect, useContext, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
// Services
import MapService from '../Services/MapService';
// Types
import * as CoreTypes from '../../../../Core/Data/Models/Core.type';
import * as MapTypes from '../Models/Map.type';
// Contexts
import UserContext, { IUserContext } from '../../../../Core/Data/Contexts/UserContext'
// Common
import CoreCommon from '../../../../Core/Resources/Common';

export interface IGetSelectionsHook extends CoreTypes.IHook<MapTypes.ISelection[]> {
  refresh: () => void
}

const useSelections = (): IGetSelectionsHook => {
  // Variables
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(['common']);

  // Contexts
  const { user }: IUserContext = useContext(UserContext)

  // State
  const [data, setData] = useState<MapTypes.ISelection[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [needRefresh, setNeedRefresh] = useState<boolean>(true);

  // Actions
  const refresh = useCallback(() => {
    setNeedRefresh(true)
  }, [])

  // Effects
  useEffect(() => {
    if (needRefresh && !isLoading) {
      setIsLoading(true)
      MapService.getSelections(user?.profile.person.account.id)
        .then((data: MapTypes.IData<MapTypes.ISelection>) => {
          setData(data.data)
        })
        .catch((e: CoreTypes.IWsException) => {
          enqueueSnackbar(
            e?.error?.message || t('common:errors.defaultMessage'),
            {
              ...CoreCommon.Constantes.snackbarDefaultProps,
              variant: 'error',
            }
          );
        }).finally(() => {
          setNeedRefresh(false)
          setIsLoading(false);
        })
    }
  }, [enqueueSnackbar, isLoading, needRefresh, t, user])

  return { data, isLoading, refresh }
}

export default useSelections